import CanvasDragTarget, { DRAG_TARGET_TYPE, measureVisibleBounds } from './CanvasDragTarget';

// A picture on the canvas. The only kind of target that is resized as well as moved, so it is also
// where the corner squares reach for the sprite: the resize controller works through these methods
// and never touches the PIXI sprite itself.
export default class ImageElementDragTarget extends CanvasDragTarget {

    constructor(imageElement, onCommit) {
        super(`image:${imageElement.config.id}`, DRAG_TARGET_TYPE.IMAGE);

        this.imageElement = imageElement;
        this.onCommit = onCommit;
    }

    get canResize() {
        return true;
    }

    // A sprite carries no filter padding in its bounds and is never rotated, so its bounding box is the
    // picture's own rectangle. Transparent parts of a PNG are still grabbable.
    getBounds() {
        if (!this.imageElement.sprite.texture.baseTexture.valid)
            return null;

        return measureVisibleBounds([this.imageElement.sprite]);
    }

    getPosition() {
        return { ...this.imageElement.config.position };
    }

    moveTo(position) {
        this.imageElement.moveTo(position);
    }

    commit(position) {
        this.onCommit(this.imageElement.config.id, { position });
    }

    // ── Resizing ─────────────────────────────────────────────────────────

    getSizeFactor() {
        return this.imageElement.getSizeFactor();
    }

    getNaturalSize() {
        return this.imageElement.getNaturalSize();
    }

    resizeTo(sizeFactor) {
        this.imageElement.fitIntoBox(sizeFactor);
    }

    // One action carrying both, so a single undo puts the picture back at the size AND the place it was
    // before the gesture.
    commitResize(sizeFactor, position) {
        this.onCommit(this.imageElement.config.id, { sizeFactor, position });
    }
}
